<script>
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

//sitecling
import VueCookies from 'vue-cookies';

export default {
  name: 'TheSiteHeader',
  props: {
    debugMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cancel: null,
      isMenuOpened: false,
      isOverlayVisible: false,
      isScrolling: false,
      isSearchOpened: false,
      lang: 'en',
      openedSubmenu: null,
      previousPosition: 0,
      previousScrollDirection: 'up',
      query: '',
      results: [],
      scrollDirection: 'up',
      scrollTimer: null,
      target: null,
      windowWidth: 0,
      theSiteclingHeight: 0,
      menuOffset: 0,
      menuHeight: 0,
    };
  },
  computed: {
    formatedResults() {
      return this.results.map((result, index) => {
        if (this.query === '' || index === this.results.length - 1) return result;

        const queryKeywords = this.query.replace(' ', '|');
        return {
          href: result.href,
          text: result.text.replace(new RegExp(`(${queryKeywords})`, 'gi'), '<strong class="text-blue">$1</strong>'),
          category: result.category,
        };
      });
    },
  },
  created() {
    this.lang = document.querySelector('html').lang || 'en';
    document.addEventListener('click', this.closeAll);
    window.addEventListener('resize', debounce(() => this.setSizeVars(), 150));
  },

  mounted() {
    window.addEventListener('scroll', throttle(() => this.setDocked(), 150), { passive: true });

    //clean current section classes and add only to the current section after URL check
    this.currentSection();

    // Donate button heartbeat
    this.startHeartbeat();
    
    //Sitecling
    this.updateSiteclingHeight();
    window.addEventListener('resize', debounce(() => this.updateSiteclingHeight(), 150));
    this.setSizeVars();
    this.setMenuHeight();
    document.documentElement.style.setProperty('--menu-offset', this.menuOffset + 'px');
    document.documentElement.style.setProperty('--menu-transform', 'translate3d(0, 0, 0)');
  },

  methods: {

    // Heartbeat effect for donation button
    startHeartbeat() {
      document.querySelector('.site-header__donate').classList.add('btn__heartbeat');
      setTimeout(() => document.querySelector('.site-header__donate').classList.remove('btn__heartbeat'), 6000);
    },

    updateSiteclingHeight() {
      this.theSiteclingHeight = this.$refs.siteclingContent.clientHeight;
      this.setSizeVars();
    },
    
    setSizeVars() {
      this.headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      this.windowWidth = document.body.clientWidth;
      this.menuOffset = this.headerHeight + this.theSiteclingHeight;
    },

    setMenuHeight() {
      this.menuHeight = this.menuOffset;
    },

    closeAll() {
      this.closeSearch();
      this.closeMenu();
      this.closeSubmenu();
    },

    // menu

    currentSection() {
      console.log('--> Current section function called');

      // Remove existing "current" classes
      const currentLinks = document.querySelectorAll('.main-menu__link--current');
      currentLinks.forEach(link => {
        link.classList.remove('main-menu__link--current');
        console.log('--> Class removed');
      });

      // Get the current path
      const currentPath = window.location.pathname;
      console.log('--> Current path:', currentPath);

      // Find all ".submenu__all" links
      const submenuAllLinks = document.querySelectorAll('.submenu__all');

      submenuAllLinks.forEach(subLink => {
        const href = subLink.getAttribute('href');

        // Check if href matches any part of the current path
        if (currentPath.includes(href)) {
          // Find closest <li class="main-menu__item">
          const menuItem = subLink.closest('.main-menu__item');

          if (menuItem) {
            // Find the button/link with class "main-menu__link" inside it
            const mainLink = menuItem.querySelector('.main-menu__link');
            if (mainLink) {
              mainLink.classList.add('main-menu__link--current');
              console.log('--> Class added to', mainLink);
            }
          }
        }
      });
    },

    closeMenu() {
      this.isMenuOpened = false;
      this.openedSubmenu = null;
      this.isOverlayVisible = false;
      enableBodyScroll(this.$el.querySelector('.main-menu__content'));
    },
    openMenu() {
      this.isMenuOpened = true;
      this.isSearchOpened = false;

      if (this.isMobile()) {
        disableBodyScroll(this.$el.querySelector('.main-menu__content'));
        this.isOverlayVisible = true;
      } else {
        this.isOverlayVisible = false;
      }
    },
    toggleMenu() {
      if (this.isMenuOpened) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },
    setDocked() {
      const position = window.scrollY;

      // docking

      const isDocked = position > 80;
      const alreadyDocked = document.body.classList.contains('is-docked');

      if (isDocked && !alreadyDocked) {
        this.closeAll();
        document.body.classList.add('is-docked');
        document.documentElement.style.setProperty('--menu-offset', '0px');
      } else if (!isDocked && alreadyDocked) {
        document.body.classList.remove('is-docked');
      }

      // scrolling motion

      document.body.classList.add('is-scrolling');
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => document.body.classList.remove('is-scrolling'), 500);

      // scroll direction

      this.scrollDirection = position > this.previousPosition ? 'down' : 'up';

      if (this.scrollDirection !== this.previousScrollDirection) {
        if (this.scrollDirection === 'up') {
          document.documentElement.style.setProperty('--menu-offset', this.menuOffset + 'px');
          document.body.classList.add('is-scrolling-up');
          document.documentElement.style.setProperty('--menu-transform', 'translateZ(0)');
          this.startHeartbeat();
        } else {
          document.documentElement.style.setProperty('--menu-offset', '0px');
          document.body.classList.remove('is-scrolling-up');
          this.closeAll();
        }
        this.previousScrollDirection = this.scrollDirection;
      } else {
        document.documentElement.style.setProperty('--menu-transform', 'translate3d(0,-' + this.menuOffset + 'px, 0)');
      }

      this.previousPosition = position;
    },

    // submenu

    closeSubmenu() {
      this.openedSubmenu = null;

      if (this.target && this.isMobile()) {
        this.$nextTick(() => {
          this.target.focus();
          this.target = null;
        });
      }

      if (!this.isMobile()) {
        this.isOverlayVisible = false;
      }
    },
    openSubmenu(id) {
      this.openedSubmenu = id;
      this.isOverlayVisible = true;
    },
    toggleSubmenu(e, id) {
      if (this.openedSubmenu === id) {
        this.target = null;
        this.closeSubmenu();
      } else {
        this.target = e.currentTarget;
        this.openSubmenu(id);
      }
    },
    tryCloseSubmenu(e) {
      if (!e.shiftKey) {
        e.preventDefault();
        this.closeSubmenu();
      }
    },
    mainMenuFirstLinkShiftTab(e) {
      if (this.isMobile()) {
        e.preventDefault();
        this.$refs.menuToggle.focus();
      }
    },
    mainMenuLinkShiftTab() {
      this.closeSubmenu();
    },

    // search

    closeSearch(updateFocus = false) {
      this.isSearchOpened = false;
      this.isOverlayVisible = false;
      if (updateFocus) this.focusSearchOpen();
    },
    openSearch() {
      this.isSearchOpened = true;
      this.closeMenu();
      this.closeSubmenu();
      this.isOverlayVisible = true;
      this.focusSearchInput();
    },
    search(event) {
      if (event && event.target) {
        this.query = event.target.value;
      }
      if (this.query.length < 3) return;
      if (this.cancel) this.cancel();
    },

    // mobile focus

    focusMenuToggle(e) {
      if (this.isMobile() && this.isMenuOpened && !e.shiftKey) {
        e.preventDefault();
        this.$refs.menuToggle.focus();
      }
    },
    focusLastMenuItem(e) {
      if (this.isMobile() && this.isMenuOpened) {
        e.preventDefault();
        this.$refs.lastMenuItem.focus();
      }
    },
    focusHamburgerToMainMenu(e) {
      if (this.isMobile() && this.isMenuOpened && !e.shiftKey) {
        e.preventDefault();
        Array.from(this.$el.querySelectorAll('.main-menu__link'))
          .find((el) => this.isVisible(el))
          .focus();
      }
    },

    // search focus

    focusSearchInput() {
      const searchInput = this.$el.querySelector('[role="combobox"]');
      if (searchInput) {
        this.$nextTick(() => {
          searchInput.focus();
        });
      }
    },
    focusSearchClose() {
      this.$refs.searchClose.focus();
    },
    focusSearchOpen() {
      this.$nextTick(() => {
        this.$refs.searchButton.focus();
      });
    },

    // utilities

    isVisible(el) {
      const styles = window.getComputedStyle(el, null);
      const display = styles.getPropertyValue('display');
      const visibility = styles.getPropertyValue('visibility');
      return display !== 'none' && visibility !== 'hidden' && el.offsetWidth > 0 && el.offsetHeight > 0;
    },

    isMobile() {
      return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 1400;
    },

    // sitecling
    closeSiteclingPanel() {
      this.updateSiteclingHeight()
      document.documentElement.style.setProperty('--menu-offset', this.menuOffset + 'px'); 
    }
  },
};
</script>